import styled from 'styled-components';

export const WuthoutElementsWrap = styled.div`
    height: 100%;
    width: 100%;
    min-height: 0;
    flex: 1;
    padding: 0.75rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: ${({ theme }) => theme.colors['silver-700']};

    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08) inset;
    border-radius: 1.25rem;
`;

export const WrapText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    span {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors['silver-500']};
        flex-wrap: wrap;
    }
`;
